"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = encodeFormData;

var _recursiveBracket = _interopRequireDefault(require("../recursiveBracket"));

var _flattenDeepPropertyList = _interopRequireDefault(require("../flattenDeepPropertyList"));

// utils

/**
 * Transforme un objet en form-data.
 * @param {object} obj
 * @return {FormData}
 */
function encodeFormData(obj) {
  const flattenObj = (0, _flattenDeepPropertyList.default)(obj, undefined, true);
  const formData = new FormData();

  for (const field of flattenObj) {
    const [fieldNameArr, fieldValue] = field;

    if (undefined !== fieldValue && "function" !== typeof fieldValue && false !== fieldValue) {
      const fieldName = (0, _recursiveBracket.default)(fieldNameArr);

      if (true === fieldValue) {
        // Si le champ vaut `true`, on renvoie la valeur "1".
        formData.set(fieldName, "1");
      } else if (null === fieldValue) {
        // Si le champ est un null, on le convertit "".
        formData.set(fieldName, "");
      } else if ( // S’il s’agit d’un tableau ou d’un objet vide, on souhaite le transformer en valeur vide (et surtout pas le supprimer).
      ("[object Object]" === Object.prototype.toString.call(fieldValue) || Array.isArray(fieldValue)) && 0 === Object.keys(fieldValue).length) {
        formData.set(fieldName, "");
      } else {
        formData.set(fieldName, fieldValue);
      }
    }
  }

  return formData;
}